import { Component, Prop, Vue } from 'vue-property-decorator';
import type { IReferenceItem } from '@/shared/model/briefing-widget.model';
import { formatDate } from '@/util/date-util';
import { namespace } from 'vuex-class';

const briefingStore = namespace('briefingStore');

@Component({
  methods: { formatDate },
})
export default class RefCardItem extends Vue {
  @Prop(Object) readonly formModel: IReferenceItem;
  @Prop(Boolean) readonly removeAble: boolean;
  @Prop(Boolean) readonly isFileCard: boolean;
  @Prop(Boolean) readonly isHasLink: boolean;

  @briefingStore.Getter
  getAddingReferenceDocuments!: Array<any>;

  tempDate = '';

  mounted() {
    this.tempDate = this.formModel.published_at || this.formModel.originDate || '';
  }

  openLink() {
    this.$emit('openLink');
  }

  emitRemove() {
    this.$emit('remove');
  }

  emitToggleBookmark() {
    this.$emit('toggleBookmark');
  }
}
